module.exports = __webpack_public_path__ + "static/media/connect-wallet-slide-4.c9ee04a6.svg";